import { NotifyIcon } from 'web-components';
import FormAlertWrapper from './elements';

interface FormAlertProps {
  message: string;
}

const FormAlert = ({ message }: FormAlertProps) => (
  <FormAlertWrapper>
    <NotifyIcon iconName="error" style={{ marginRight: '.5rem' }} />
    {message}
  </FormAlertWrapper>
);

export default FormAlert;
